import { render, staticRenderFns } from "./ScalePoints.vue?vue&type=template&id=61a053e0&scoped=true"
import script from "./ScalePoints.vue?vue&type=script&lang=ts"
export * from "./ScalePoints.vue?vue&type=script&lang=ts"
import style0 from "./ScalePoints.vue?vue&type=style&index=0&id=61a053e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a053e0",
  null
  
)

export default component.exports